import styled from 'styled-components'

export const Content = styled.div`
  width: 100%;
  font-family: 'Inter', sans-serif;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  > * {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }
`